export const version = "solidity/5.6.1";
//# sourceMappingURL=_version.js.map